// extracted by mini-css-extract-plugin
module.exports = {"item":"animationItem_item__zTt8S","visible":"animationItem_visible__SshtT","hidden":"animationItem_hidden__amDQG","hide":"animationItem_hide__KDKgE"};